import type { ReactNode } from 'react';
import styles from './MiniTile.module.css';

type MiniTileProps = {
  /** Small glyph in top-left. Accepts any JSX (SVG icon, emoji, etc.). */
  glyph: ReactNode;
  /** CSS background color for the glyph container. Default --cream-2. */
  glyphBg?: string;
  /** Uppercase hint text in top-right of the tile header. */
  hint: string;
  /** Main value — typically serif + tabular-nums via `.serif .tnum` classes. */
  children: ReactNode;
};

/**
 * Generic 2-up tile wrapper. Used for weather and streak tiles in the
 * mobile pair grid below the hero. Consumer passes the glyph, hint, and
 * arbitrary content children (big value, heatmap, etc.).
 */
export function MiniTile({ glyph, glyphBg, hint, children }: MiniTileProps) {
  return (
    <div className={styles.tile}>
      <div className={styles.top}>
        <div className={styles.glyph} style={glyphBg ? { background: glyphBg } : undefined}>
          {glyph}
        </div>
        <div className={styles.hint}>{hint}</div>
      </div>
      {children}
    </div>
  );
}
